import $ from 'jquery';
import { breakpoints } from './_site';

let timeout = {};

export const selectItem = ($el) => {
    let $parent = $el.closest('.custom-dropdown'),
        $input = $parent.find('input'),
        defaultClass = 'custom-dropdown__choices__item',
        activeClass = defaultClass + '--active',
        $selected = $parent.find('.custom-dropdown__selected'),
        $choices = $parent.find('.custom-dropdown__choices');

    $choices
        .find('.' + defaultClass)
        .not($el)
        .removeClass(activeClass);
    $el.addClass(activeClass);
    $selected.html($el.html());

    $input.val($el.data('value'));

    hideDropdown($el);
};
export const hideDropdown = ($el) => {
    let $parent = $el.closest('.custom-dropdown'),
        activeClass = 'custom-dropdown--active';

    $parent.removeClass(activeClass);
};
export const toggleDropdown = ($el) => {
    let $parent = $el.closest('.custom-dropdown'),
        activeClass = 'custom-dropdown--active';

    $parent.toggleClass(activeClass);
};
export const binds = () => {
    // -------------------
    // BINDS
    // -------------------
    $('#content').on('click', '[data-toggle-custom-dropdown]', function() {
        toggleDropdown($(this));
    });
    $('#content').on('click', '[data-custom-dropdown-select]', function() {
        selectItem($(this));
    });
    $(document).on('click', function(event) {
        let $target = $(event.target),
            activeDropdownClass = 'custom-dropdown--active',
            $dropdowns = $('.custom-dropdown'),
            $activeDropdown = $target.closest('.' + activeDropdownClass);

        if (!$activeDropdown.length) {
            $dropdowns.not($activeDropdown).removeClass(activeDropdownClass);
        }
    });
};
